module.exports = __webpack_public_path__ + "img/00025.e1941a71.webp";